export default "__VITE_ASSET___fwRBI1U__"